import { ConfigRepository } from './ConfigRepository';
import { Config } from './Config';

export class ConfigRemoteRepository implements ConfigRepository {
    public async fetchConfig(): Promise<Config> {
        const data = await fetch('https://uji-apps-wifi.s3-eu-west-1.amazonaws.com/config.json')
            .then((res) => res.json())

        return data;
    }
}
